module.exports = __webpack_public_path__ + "media/components/guide-page/static/icon-boots-5d68656d834719c35849fbaa9044c4f9.svg";